import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

/**
 * Asks before a URL is opened through the PhishBox sandbox. Visiting opens the
 * page in a new tab of the user's own browser, so it is never done on a single
 * click.
 */
const SandboxVisitConfirm = ({ url, show, setShow, onConfirm }) => (
  <ConfirmDialog
    show={show}
    setShow={setShow}
    onConfirm={onConfirm}
    article="Visit URL?"
    textOK="Visit"
    textCancel="Cancel">
    <span className="confirm-dialog__subject confirm-dialog__subject--mono">{url}</span>
    <span className="confirm-dialog__note">
      This page will open in a new tab of your browser through the PhishBox sandbox. Continue
      only if you intend to interact with it.
    </span>
  </ConfirmDialog>
);

export default SandboxVisitConfirm;
